import globals from "@/utils/globals";

// Source: https://www.quirksmode.org/js/cookies.html
// Modified to be ES6 compatible

const VALID_DAYS = 30;

const create = (name, value, days = VALID_DAYS, domain = null) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
  }
  let secure = "";
  if (globals.env !== "development") {
    secure = " secure";
  }

  if (domain) {
    document.cookie = `${name}=${value}${expires}${secure}; path=/; domain=${domain}; SameSite=Lax`;
  } else {
    document.cookie = `${name}=${value}${expires}${secure}; path=/; SameSite=Strict`;
  }
};

const read = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export default (name, value, days, domain) => {
  if (typeof value === "undefined") {
    return read(name);
  } else {
    return create(name, value, days, domain);
  }
};

export const eraseCookie = (name) => {
  create(name, "", -1);
};
